import React from 'react';
import { useNavigate } from 'react-router-dom';

function PatientBasicDetails({ patientData }) {
  const navigate = useNavigate();
  const { firstname, age, gender, patientguid, createddate, symptomdetails } =
    patientData;

  return (
    <div className="mb-6 rounded-xl border bg-white p-4 shadow-sm">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="px-3 py-2 text-left text-gray-700">Name</th>
            <th className="px-3 py-2 text-left text-gray-700">Age</th>
            <th className="px-3 py-2 text-left text-gray-700">Symptoms</th>
            <th className="px-3 py-2 text-left text-gray-700">Gender</th>
            <th className="px-3 py-2 text-left text-gray-700">Created On</th>
            <th className="px-3 py-2 text-left text-gray-700">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border-b border-gray-100 px-3 py-2">{firstname}</td>
            <td className="border-b border-gray-100 px-3 py-2">{age}</td>
            <td className="border-b border-gray-100 px-3 py-2">
              {symptomdetails?.length || 'NA'}
            </td>
            <td className="border-b border-gray-100 px-3 py-2">{gender}</td>
            <td className="border-b border-gray-100 px-3 py-2">
              {new Date(createddate).toLocaleDateString()}
            </td>
            <td className="border-b border-gray-100 px-3 py-2">
              <button
                onClick={() => navigate(`/patients/${patientguid}`)}
                className="rounded bg-blue-900 px-3 py-1 text-white"
              >
                View Data
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default PatientBasicDetails;
